module.exports = __webpack_public_path__ + "media/images/concept_leadership-fdb55a97d8bfad368a1bc89f9fd4b21c.png";